import { HEALTH_ABOUT_YOU_STEP } from "Components/Features/CheckPrice/Products/LifeProducts/Health";
import { HealthProductIntroFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/Health/ProductIntro/healthProductIntroInterfaces";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { formBooleanToBoolean } from "Utils/formUtils";

export interface HealthProductBackend {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: string;
  dateOfBirth: string;
  isScandinavianCitizen: boolean;
  isFemale: boolean;
  isSmoker: boolean;
}

export const mapToCommerceHealth = (
  data: Record<string, any>,
): HealthProductBackend => {
  const healthIntroData: HealthProductIntroFormValues =
    data.formData[HEALTH_ABOUT_YOU_STEP.id];

  return {
    name: INSURANCE_NAME_VALUE.HEALTH,
    coverageGroup: data.coverage,
    dateOfBirth: data.customerData.newCustomerResponse.dateOfBirth,
    isScandinavianCitizen: formBooleanToBoolean(
      healthIntroData.isMemberOfNordicSocialSecurity,
    ),
    isFemale: data.customerData.newCustomerResponse.isFemale,
    isSmoker: false,
  };
};
